import { useState, useTransition } from 'react';
import {  useNavigate } from 'react-router-dom';

export const useBatchConfigList = () => {
  const navigate = useNavigate();
  const [searchString, setSearchString] = useState<string>('');
  const [isPending, startTransition] = useTransition();
  function handleSearch(value: string) {
    startTransition(() => {
      setSearchString(value);
    });
  }

  function handleRowClick (batchConfigurationId: string) {
    navigate(`createEditBatchConfig/${batchConfigurationId}`);
  };

  function handleAddBatchConfig(event: React.MouseEvent<HTMLButtonElement>) {
    event.stopPropagation();
    navigate('createEditBatchConfig');
  }


  return {
    searchString,
    isPending,
    handleSearch,
    handleAddBatchConfig,
    handleRowClick,
  };
};
